var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section__tags"},[_vm._l((_vm.items),function(item){
var _obj;
return _c('button',{key:item.term_id,staticClass:"section__button section__button-flex section__button--blue",class:[
      'section__button',
      'section__button-flex',
      ("section__button--" + _vm.theme),
      ( _obj = {}, _obj[("section__button--" + _vm.theme + "-active")] = item.term_id === _vm.active, _obj ) ],on:{"click":function($event){return _vm.filter(item)}}},[_c('div',[_c('span',{domProps:{"innerHTML":_vm._s(item.name)}}),(item.term_id === _vm.active)?_c('span',{staticClass:"icon__close--white"}):_vm._e()])])}),_c('div',{staticClass:"spacer"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }